import React from "react";
import { Button, Modal, Tabs, Tab, Table } from "react-bootstrap";
import ReactTable from 'react-table';
import "react-table/react-table.css";

import HomeBtn from './HomeBtn';
import { listLoggedInServers } from "./include/Server";
import Util from "./include/Util";


export default class GamesApp extends React.Component {
    constructor(props) {
        super(props);

        const servers = listLoggedInServers();

        let games = {};
        let pages = {};
        let loading = {};
        let errorMsg = {};

        servers.forEach((server) => {
            games[server.name] = [];
            pages[server.name] = 0;
            loading[server.name] = true;
            errorMsg[server.name] = undefined;
        });

        this.state = {
            games: games,
            pages: pages,
            loading: loading,
            errorMsg: errorMsg,
            modalData: undefined,
        };

        this.initGameClose = this.initGameClose.bind(this);
        this.abortGameClose = this.abortGameClose.bind(this);
        this.confirmGameClose = this.confirmGameClose.bind(this);
        this.fetchGames = this.fetchGames.bind(this);
    }

    initGameClose(server, row) {
        const game = row.original;

        console.log("Closing game", server, game);

        server.get(server.createUrl('/game/' + game.id + '/events?count=1000', {}),
            (data) => {
                this.setState((state, pros) => {
                        let updatedModalData = state.modalData;
                        updatedModalData.events = data.events;
                        return {
                            modalData: updatedModalData,
                        };
                });
            },
            (error) => {
                console.error(error);
                // FIXME: Indicate error to user
            }
        );

        this.setState({
            modalData: {
                server: server,
                game: game,
                events: undefined,
            }
        });
    }

    abortGameClose() {
        this.setState({
            modalData: undefined,
        });
    }

    confirmGameClose() {
        const { modalData } = this.state;

        console.log('Officially closing game', modalData);

        const server = modalData.server;
        const game = modalData.game;

        const putBody = {
            'officially_closed': true,
        };

        server.put(server.createUrl('/game/' + game.id, {}),
            putBody,
            (_) => {
                game.officially_closed = true;
                this.setState({
                    modalData: undefined,
                });
            },
            (error) => {
                console.error(error);
                this.setState((state, pros) => {
                    let updatedErrorMsg = state.errorMsg;
                    updatedErrorMsg[server.name] = 'Could not close game: ' + error;
                    return {
                        modalData: undefined,
                        errrorMsg: updatedErrorMsg,
                    };
                });
            }
        );
    }

    fetchGames(table) {
        const server = table.server;

        console.log('Fetching from ', server, table);

        const now = new Date();

        const params = {
            to_date: now.getUTCFullYear() + '-' + (now.getUTCMonth()+1) + '-' + now.getUTCDate(),
            from: table.pageSize * table.page,
            count: table.pageSize,
        };

        this.setState((state, pros) => {
            let updatedLoading = state.loading;
            updatedLoading[server.name] = true;
            return {
                loading: updatedLoading,
            };
        });

        server.get(server.createUrl('/game', params),
            (data) => {
                this.setState((state, pros) => {
                        let updatedGames = state.games;
                        let updatedPages = state.pages;
                        let updatedLoading = state.loading;
                        let updatedErrorMsg = state.errorMsg;
                        updatedGames[server.name] = data.games;
                        updatedPages[server.name] = Math.ceil(data.total / table.pageSize);
                        updatedLoading[server.name] = false;
                        updatedErrorMsg[server.name] = undefined;
                        return {
                            games: updatedGames,
                            pages: updatedPages,
                            loading: updatedLoading,
                            errorMsg: updatedErrorMsg,
                        };
                });
            },
            (error) => {
                console.error(error);
                this.setState((state, pros) => {
                    let updatedLoading = state.loading;
                    let updatedErrorMsg = state.errorMsg;
                    updatedLoading[server.name] = false;
                    updatedErrorMsg[server.name] = "Error fetching games from server " + server.name + ": " + error;
                    return {
                        loading: updatedLoading,
                        errorMsg: updatedErrorMsg,
                    };
                });
            }
        );
    }

    renderGames(server) {
        const { games, pages, loading } = this.state;

        return (
            <div>
                <div style={{color: "red"}}>{this.state.errorMsg[server.name]}</div>
                <ReactTable
                    columns={[
                        {
                            Header: () => (
                                <div style={{
                                    textAlign:"left"
                                }}>Date</div>
                            ),
                            accessor: "date",
                        },
                        {
                            Header: () => (
                                <div style={{
                                    textAlign:"left"
                                }}>Home Team</div>
                            ),
                            accessor: "home_team.name",
                        },
                        {
                            Header: () => (
                                <div style={{
                                    textAlign:"left"
                                }}>Visiting Team</div>
                            ),
                            accessor: "visiting_team.name",
                        },
                        {
                            Header: () => (
                                <div style={{
                                    textAlign:"left"
                                }}>Score</div>
                            ),
                            accessor: "score",
                            Cell: row => {
                                return row.original.home_team_goals + ' : ' + row.original.visiting_team_goals;
                            }
                        },
                        {
                            Header: () => (
                                <div style={{
                                    textAlign:"left"
                                }}>Phase</div>
                            ),
                            accessor: "phase",
                            Cell: row => {
                                return row.original.phase;
                            }
                        },
                        {
                            Header: () => (
                                <div style={{
                                    textAlign:"left"
                                }}>Officially Closed</div>
                            ),
                            accessor: 'officially_closed',
                            Cell: row => {
                                return (
                                    <Button type="button"
                                            bsStyle={row.value ? "default" : "primary"}
                                            onClick={() => this.initGameClose(server, row)}
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                    >
                                        <span className={row.value ? "glyphicon glyphicon-ok" : "glyphicon glyphicon-remove"} aria-hidden="true" />
                                        <span style={{marginLeft: "10px"}}>{row.value ? "Closed" : "Review"}</span>
                                    </Button>
                                );
                            }
                        },
                    ]}
                    manual
                    sortable={false}
                    data={games[server.name]}
                    pages={pages[server.name]}
                    loading={loading[server.name]}
                    onFetchData={this.fetchGames}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    server={server}
                />
            </div>
        );
    }

    renderAggregateEventStats(events) {
        let goals = [];
        let redCards = [];
        let yellowCards = [];
        let penalties = [];
        let substitutations = [];

        events.forEach((e) => {
           if (e.tag.action === 'goal') {
               goals.push(e);
           } else if (e.tag.action === 'yellow card') {
               yellowCards.push(e);
           } else if (e.tag.action === 'red card') {
               redCards.push(e);
           } else if (e.tag.action === 'penalty') {
               penalties.push(e);
           } else if (e.tag.action === 'substitution') {
               substitutations.push(e);
           }
        });

        console.log('goals:', goals, 'yellow:', yellowCards, 'red:', redCards, 'penalties:', penalties);

        const showEventTime = (e) => (
            <div style={{minWidth: "110px", display: "inline-block"}}>
                {Util.padLeadingZeroes(Math.ceil(e.game_time/60),2)}:{Util.padLeadingZeroes(Math.floor(e.game_time % 60),2)} {e.game_phase}:
            </div>
        );

        const showValueIfExists = (tag, property, required=true) => {
            const exists = tag[property] !== undefined;
            if (!exists && required) return <i style={{color: 'darkred'}}>*{property} missing*</i>;
            return <span>{tag[property].value}</span>
        };

        const rGoals = goals.map((e) => (
            <tr key={e.id}>
                <td/><td>
                {showEventTime(e)} <b>{showValueIfExists(e.tag, 'scorer')}</b>, {showValueIfExists(e.tag, 'team')}</td>
            </tr>
        ));

        const rRedCards = redCards.map((e) => (
            <tr key={e.id}>
                <td/><td>
                {showEventTime(e)} <b>{showValueIfExists(e.tag, 'player')}</b>, {showValueIfExists(e.tag, 'team')}</td>
            </tr>
        ));

        const rYellowCards = yellowCards.map((e) => (
            <tr key={e.id}>
                <td/><td>
                {showEventTime(e)} <b>{showValueIfExists(e.tag, 'player')}</b>, {showValueIfExists(e.tag, 'team')}</td>
            </tr>
        ));

        const rPenalties = penalties.map((e) => (
            <tr key={e.id}>
                <td/><td>
                {showEventTime(e)} {showValueIfExists(e.tag, 'team')}</td>
            </tr>
        ));

        const rSubstitutions = substitutations.map((e) => (
            <tr key={e.id}>
                <td/><td>
                {showEventTime(e)} In: {showValueIfExists(e.tag, 'player in')} Out: {showValueIfExists(e.tag, 'player out')}, {showValueIfExists(e.tag, 'team')}</td>
            </tr>
        ));

        return (
            <Table>
                <tbody>
                    <tr>
                        <td style={{width: "15%", fontWeight: 'bold'}}>Goals</td>
                        <td style={{width: "85%", fontWeight: 'bold'}}>{goals.length}</td>
                    </tr>
                    {rGoals}
                    <tr>
                        <td style={{width: "15%", fontWeight: 'bold'}}>Red Cards</td>
                        <td style={{width: "85%", fontWeight: 'bold'}}>{redCards.length}</td>
                    </tr>
                    {rRedCards}
                    <tr>
                        <td style={{width: "15%", fontWeight: 'bold'}}>Yellow Cards</td>
                        <td style={{width: "85%", fontWeight: 'bold'}}>{yellowCards.length}</td>
                    </tr>
                    {rYellowCards}
                    <tr>
                        <td style={{width: "15%", fontWeight: 'bold'}}>Penalties</td>
                        <td style={{width: "85%", fontWeight: 'bold'}}>{penalties.length}</td>
                    </tr>
                    {rPenalties}
                    <tr>
                        <td style={{width: "15%", fontWeight: 'bold'}}>Substitutions</td>
                        <td style={{width: "85%", fontWeight: 'bold'}}>{substitutations.length}</td>
                    </tr>
                    {rSubstitutions}
                </tbody>
            </Table>
        );
    }

    renderGameConfirmationModal() {
        const { modalData } = this.state;

        if (modalData === undefined) {
            return undefined;
        }

        const alreadyClosed = modalData.game.officially_closed;

        const aggregateEventStats = (modalData.events === undefined) ?
            (<div style={{width: '100%', textAlign: 'center'}}>... Loading ...</div>)
            : this.renderAggregateEventStats(modalData.events);

        return (
            <Modal show={true} onHide={this.abortGameClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Game Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table>
                        <tbody>
                        <tr>
                            <td style={{width: "15%"}}>Date</td>
                            <td style={{width: "85%"}}>{modalData.game.date}</td>
                        </tr>
                        <tr>
                            <td>Name</td>
                            <td>{modalData.game.home_team.name} vs. {modalData.game.visiting_team.name}</td>
                        </tr>
                        <tr>
                            <td>Score</td>
                            <td style={{fontWeight: 'bold'}}>{modalData.game.home_team_goals} : {modalData.game.visiting_team_goals}</td>
                        </tr>
                        <tr>
                            <td>Phase</td>
                            <td>{modalData.game.phase}</td>
                        </tr>
                        <tr>
                            <td>Referee</td>
                            <td>{modalData.game.referee_name}</td>
                        </tr>
                        </tbody>
                    </Table>
                    {aggregateEventStats}
                </Modal.Body>
                <Modal.Footer>
                    {alreadyClosed ? (
                        <Button bsStyle="default"
                                onClick={this.abortGameClose}
                                style={{
                                    width: '100%',
                                    fontWeight: 'bold',
                                }}>
                            Game already closed
                        </Button>
                    ) : (
                        <Button bsStyle="success"
                                onClick={this.confirmGameClose}
                                style={{
                                    width: '100%',
                                    fontWeight: 'bold',
                                }}>
                            Result is final
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        )
    }

    render() {
        const servers = listLoggedInServers();

        const game_listing_tabs = servers.map((server) => {
            const title = server.name;
            return (
                <Tab key={title} eventKey={title} title={title}>
                    {this.renderGames(server)}
                </Tab>
            );
        });

        const active_server = servers[0].name;

        return (
            <div className="row" id="management-app">
                <HomeBtn style={{position: "absolute", left: "8px", top: "4px", height: "40px"}} />
                <Tabs defaultActiveKey={active_server} id="management-app-tabs" style={{position: "absolute", left: "8px", right: "8px", top: "60px"}}>
                    {game_listing_tabs}
                </Tabs>
                {this.renderGameConfirmationModal()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/GamesApp.js